import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { RunnerDetails } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RunnerDetails';
import { LazyImageSilk } from 'src/domains/sportsbook/webview/components/lazyImage/LazyImageSilk';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { Chart } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/horseRacing/RaceSummaryRowHorseRacing.style';
import {
    CellRunner,
    CellRunnerInfoWrapper,
    JockeyAndTrainerDetailsBox,
    SilkCellRaceSummaryWrapper,
} from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRowSport/RaceCard/RaceCardRunner.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    handleDetailsClick: () => void;
    isPriceBoostActive?: boolean;
    isExpanded: boolean;
    selectionId: SelectionId;
    tagsCountry?: string | undefined;
}

export const RaceCardRunner = observer('RaceCardRunner', (props: PropsType) => {
    const { handleDetailsClick, isExpanded, selectionId, isPriceBoostActive, tagsCountry } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const selectionModel = selectionId.getModel();

    if (selectionModel === null) {
        return null;
    }

    const isDetailsAvailable = selectionModel.templateId !== 'unnamed-favourite';
    const isRasGoldActive = tagsCountry !== undefined && configState.rasGoldCountries.includes(tagsCountry);

    const silkUrl = selectionModel.metaDataSilkUrl ?? '';
    const silkAltDesc = selectionModel.metaDataSilk ?? 'Silk image';

    return (
        <CellRunner>
            <SilkCellRaceSummaryWrapper>
                <LazyImageSilk
                    imgBase={{
                        src: silkUrl,
                        optimizeOptions: {
                            quality: 85,
                            width: 54,
                        },
                    }}
                    alt={silkAltDesc}
                />
            </SilkCellRaceSummaryWrapper>

            <CellRunnerInfoWrapper isRasGoldActive={isRasGoldActive}>
                <JockeyAndTrainerDetailsBox
                    isDetailsAvailable={isDetailsAvailable}
                    selectionId={selectionId}
                />

                <RunnerDetails selectionId={selectionId} />

                {isRasGoldActive && isPriceBoostActive !== true && (
                    <Chart
                        isExpanded={isExpanded}
                        onClick={handleDetailsClick}
                    />
                )}
            </CellRunnerInfoWrapper>
        </CellRunner>
    );
});
